import type { Message } from '../components/ChatMessage/types';

// Mirrors the backend's without_last_turn: the trailing answer and the question it answered.
export const withoutLastTurn = (messages: Message[]): Message[] => {
  const trimmed = [...messages];
  if (trimmed[trimmed.length - 1]?.role === 'assistant') trimmed.pop();
  if (trimmed[trimmed.length - 1]?.role === 'user') trimmed.pop();

  return trimmed;
};
